import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import OchaIcon from "./OchaIcon";

const iconStat = [
    {
        icon: "Rural",
        text: "3,869+ Villages Reached",
    },
    {
        icon: "Map",
        text: "13 Districts of Maharashtra",
    },
    {
        icon: "Fund",
        text: "70+ Projects Executed",
    },
    {
        icon: "People-targeted",
        text: "10,000+ Beneficiaries Annually",
    },
    {
        icon: "Staff-management",
        text: "13 Professionals & 48 Experts",
    },
    {
        icon: "Group",
        text: "400+ Self-Help Groups Formed",
    },
];

const IconStat = () => {
    return (
        <Container fluid style={{ backgroundColor: "#E8F5E9", padding: "50px 0" }}>
            <Row className="text-center">
                {iconStat.map((stat, index) => (
                    <Col key={index} xs={12} md={6} lg={2} className="mb-4">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: index * 0.2 }}
                            className="d-flex flex-column align-items-center"
                        >
                            <div
                                style={{
                                    width: "80px",
                                    height: "80px",
                                    backgroundColor: "#2E7D32",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "15px",
                                }}
                            >
                                <OchaIcon name={stat.icon} size={40} color="white" />
                            </div>
                            <p style={{ color: "#1B5E20", fontSize: "16px", fontWeight: "500" }}>
                                {stat.text}
                            </p>
                        </motion.div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default IconStat;
